import { render, staticRenderFns } from "./NormalSearchNav168.vue?vue&type=template&id=bddb6c3c&scoped=true"
import script from "./NormalSearchNav168.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav168.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb6c3c",
  null
  
)

export default component.exports